import { render } from "./ItemAdjustment_list.vue?vue&type=template&id=944c243e"
import script from "./ItemAdjustment_list.vue?vue&type=script&lang=js"
export * from "./ItemAdjustment_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__